import type { Module } from 'owa-workloads-module';
import updateModule from '../actions/updateModule';
import getStore from '../store/store';

export default function initializeModule(newModule: Module): void {
    if (!getStore().module) {
        updateModule(newModule);
    }
}
